import './Achievement.css';
import man1 from './Programmer-bro.png'
const Achievement = (props) => {
    const link = () => {
        window.open(props.alldata[0].leetcode_link, '_blank');
    }
    return (
        <div className="Achievement">
            <div className="Achievement-header">
                <h1>LeetCode Excellence</h1>
                <br></br>
                <br></br>
                <br></br>
            </div>
            <div className="Achievement-content">
                    <p>{props.alldata[0].achievement_para}
                        <br/>
                    <button className="resume-button" onClick={link}>
                    Leetcode Profile
                    </button>
                    </p>
                    <div className="Achievement-image">
                        <img src={man1} alt="sad?" />
                    </div>
            </div>
        </div>
    );
}

export default Achievement;